import {Component, ChangeDetectorRef, OnInit} from '@angular/core';
import * as _ from 'lodash';


import { StatusModel } from 'shared/search/status.model';

import { BaseScorecardComponent } from '../base/_base-scorecard.component';

import { ScorecardConnectorService } from 'shared/scorecard/scorecard-connector.service';
import { MyFitmentsSearchService } from 'shared/fitments/search/my-fitments-search.service';
import { FitmentsScorecardService } from './fitments-scorecard.service';
import {takeWhile} from 'rxjs/operators';


@Component({
  moduleId: module.id,
  selector: 'fitments-scorecard',
  templateUrl: 'fitments-scorecard.component.html',
  styleUrls: ['fitments-scorecard.component.scss'],
})
export class FitmentsScorecardComponent extends BaseScorecardComponent implements OnInit {
  segmentTitle: string = 'Fitments';
  allStatusesStatus: any = {
    name: 'All statuses',
    id: 'all',
  };
  badgeColorMap: any = {
    'all': 'midgrey', // all
    '0': 'greenhaze', // valid
    '1': 'darkred', // invalid
    '2': 'darkred', // duplicate
  };

  /*******************************************
  * COMPONENT GETTERS
  *******************************************/

  get statuses(): Array<StatusModel> {
    return this.fitmentsSearchService.statuses;
  }

  get totalRecords(): number {
    return this.fitmentsSearchService.totalRecords;
  }

  get selectedStatusId(): string|number {
    return _.get(this.fitmentsSearchService, 'searchModel.statusModel.id');
  }

  constructor(
    protected ref: ChangeDetectorRef,
    protected scorecardConnectorService: ScorecardConnectorService,
    private fitmentsSearchService: MyFitmentsSearchService,
    private fitmentsScorecardService: FitmentsScorecardService,
  ) {
    super(ref, scorecardConnectorService);
  }

  /*******************************************
  * COMPONENT HOOKS
  *******************************************/

  ngOnInit() {
    super.ngOnInit();
    this.fitmentsSearchService.searchResultsSubject
    .pipe(takeWhile(() => this.isActive))
    .subscribe((data: any) => {
      this.ref.markForCheck();
    });
  }

  /*******************************************
  * COMPONENT HANDLERS
  *******************************************/

  onFitmentsScoreClick(status: StatusModel) {
    this.fitmentsScorecardService.statusFilterChanged.emit(
      this.isAllStatus(status) ? null : status
    );
  }

  /*******************************************
  * COMPONENT PRIVATE METHODS
  *******************************************/

  private isAllStatus(status: StatusModel): boolean {
    return status.id === this.allStatusesStatus.id;
  }
}
